import { nanoid } from 'nanoid';
import { overlay } from 'overlay-kit';

type Dialog<T> = (props: T) => JSX.Element;

// overlayId 는 밖에서 못 넘긴다 — 고정 id 로 이미 열린 모달을 다시 열면
// overlay-kit reducer 가 렌더 중 throw 해 앱 전체가 죽는다 (QUIZ-APP-806).
// id 는 항상 여기서 호출마다 새로 만들고, 닫을 때는 open 의 반환값을 쓴다.
type Options<T> = Omit<T, 'isOpen' | 'onClose'>;

export const createDialogManager = <T>(Dialog: Dialog<T>) => {
  return {
    open(options: Options<T>) {
      return overlay.open(
        ({ unmount }) => Dialog({ ...(options as T), onClose: unmount }),
        { overlayId: nanoid(8) },
      );
    },

    async openAsync(options: Options<T>): Promise<boolean> {
      const overlayId = nanoid(8);
      const confirm = (await overlay.openAsync(
        ({ close }) => Dialog({ ...(options as T), onClose: close }),
        { overlayId },
      )) as boolean;
      overlay.unmount(overlayId);
      return confirm;
    },

    close(overlayId: string) {
      overlay.close(overlayId);
    },

    unmount(overlayId: string) {
      overlay.unmount(overlayId);
    },
  };
};
